import { render, staticRenderFns } from "./awards_data_tab.vue?vue&type=template&id=b2e61a8c&scoped=true"
import script from "./awards_data_tab.vue?vue&type=script&lang=js"
export * from "./awards_data_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e61a8c",
  null
  
)

export default component.exports